export default __webpack_public_path__ + "static/Food_Label_Digital_Tear_Sheet-df19ac75f51476b62cb44825860fdba0.pdf";